import { useQuery } from "react-query"
import { fetchDeals, fetchSymbols } from "../../services/main.service"
import { InputWrapper } from "./input"
import { ReactSelect } from "./select"
import { Select, Text } from "@chakra-ui/react"
import map from "lodash/map"
import { components } from "react-select"

// SELECT SYMBOLS
interface IOption {
  label: string
  value: string
}

export const SelectSymbols = ({
  selectedSymbol,
  onOptionChange,
}: {
  selectedSymbol?: string
  onOptionChange: (_option: string) => void
}) => {
  const {
    data,
    isLoading,
    isError,
    isRefetching,
    isFetched,
    isFetchedAfterMount,
  } = useQuery(["symbolsTest"], () => fetchSymbols("", 1))

  if (isLoading || !data?.length)
    return (
      <>
        <InputWrapper title="Select Symbols">
          <Text>Fetching symbols please wait....</Text>
        </InputWrapper>
      </>
    )

  const getOptions = () => {
    return [
      {
        label: "ALL",
        value: "",
      },
      ...map(data, (_option) => {
        return {
          label: _option,
          value: _option,
        }
      }),
    ]
  }

  const MenuList = function MenuList(props: any) {
    const children = props.children

    if (!children.length) {
      return <div className="myClassListName">{children}</div>
    }

    return (
      <div className="myClassListName">
        {children.length &&
          children.map((key: any, i: any) => {
            delete key.props.innerProps.onMouseMove //FIX LAG!!
            delete key.props.innerProps.onMouseOver //FIX LAG!!

            return (
              <div className="myClassItemName" key={i}>
                {key}
              </div>
            )
          })}
      </div>
    )
  }

  const Option = ({ children, ...props }: any) => {
    const { onMouseMove, onMouseOver, ...rest } = props.innerProps
    const newProps = Object.assign(props, { innerProps: rest })
    return <components.Option {...newProps}>{children}</components.Option>
  }

  return (
    <>
      <InputWrapper title="Select Symbols">
        <Select
          value={selectedSymbol}
          onChange={(e) => {
            onOptionChange(e?.target?.value)
          }}
        >
          {map(getOptions(), (_option) => (
            <option value={_option?.value}>{_option?.label}</option>
          ))}
        </Select>
      </InputWrapper>
    </>
  )

  return (
    <InputWrapper title="Select Symbols">
      <ReactSelect
        options={getOptions()}
        components={{
          MenuList,
          Option,
        }}
      />
    </InputWrapper>
  )
}
